import { useNavigate, useParams } from '@tanstack/react-router';
import { RemittanceDetailSlidein } from '@/components/accounts-receivable/remittance-detail/remittance-detail-slidein';

export function RemittanceDetailRoute() {
  const { remittanceId } = useParams({
    from: '/authenticated/accounts-receivable/remittances/$remittanceId',
  });
  const navigate = useNavigate();

  return (
    <RemittanceDetailSlidein
      remittanceId={remittanceId}
      isOpen
      onOpenChange={(open) => {
        if (!open) {
          navigate({ to: '..', search: true, viewTransition: true });
        }
      }}
    />
  );
}
